import { combineEpics } from "redux-observable";
import * as starter from "./starter";
import * as auth from "./auth";
import * as dashboard from "./dashboard";
import * as app from "./app";
import * as appFinances from "./appExpandedEpics/finances";
import * as appProperties from "./appExpandedEpics/properties";
import * as appCommunities from "./appExpandedEpics/communities"; // ✅ ADD communities epics
import * as finances from "./finances";
import * as users from "./users";
import * as merchants from "./merchants";
import * as website from "./website";

export const rootEpic = combineEpics(
  starter.loadingEpic,
  auth.loginEpic,
  auth.logOutEpic,
  auth.requestLoginCodeEpic,
  auth.verifyLoginCodeEpic,
  dashboard.getActiveUsersEpic,
  dashboard.getStatisticsSessionsEpic,
  dashboard.getPropertiesStatsEpic,
  dashboard.getCommunitiesStatsEpic,
  dashboard.getSubscriptionsStatsEpic,
  dashboard.getBankAccountStatsEpic,
  dashboard.getWalletsStatsEpic,
  dashboard.getAppGrowthStatsEpic,
  dashboard.getNotificationsEpic,
  dashboard.createNotificationEpic,
  dashboard.getActiveUsersListEpic,
  dashboard.getMostActiveUsersListEpic,
  dashboard.getReceiversEpic,
  dashboard.getUserAutoCompleteEpic,
  dashboard.getPropertiesEpic,
  dashboard.getAppDownloadsEpic,
  dashboard.getAppSessionsStatsEpic,
  dashboard.getSubscribedUsersListEpic,
  dashboard.getSubscribedCommunitiesListEpic,
  dashboard.getCommunitiesListEpic,
  dashboard.getUsersListEpic,
  dashboard.getPropertiesListEpic,
  
  // ✅ KEEP: Only general app epics (minimal)
  app.getStatsEpic,
  app.getMutualManagementsEpic,
  app.coManagementEpic,
  
  // ❌ REMOVED: Community epics moved to appCommunities
  // app.getNeighborsNoticesEpic,
  // app.getCommunityAggregatedStatsEpic,
  
  // ✅ NEW: App Finances epics
  appFinances.getFinanceAggregatedStatsEpic,
  appFinances.getWalletsEpic,
  appFinances.getTransactionsEpic,
  appFinances.getSharedWalletsEpic,
  appFinances.getBankIntegrationsEpic,
  
  // ✅ NEW: App Properties epics
  appProperties.getPropertiesAggregatedStatsEpic,
  appProperties.getRentPaymentsEpic,
  appProperties.getUtilityBillPaymentsEpic,
  appProperties.getPropertyFilesEpic,
  appProperties.getPropertyCalendarEpic,
  appProperties.getPropertyChatsEpic,
  appProperties.getPropertyQueriesEpic,
  appProperties.getPropertyInvitationsEpic,
  appProperties.getLandlordTenantInvitationsEpic,
  appProperties.getSharedManagementInvitationsEpic,
  
  // ✅ NEW: Utility Bill Management epics
  appProperties.markUtilityBillAsPaidEpic,
  appProperties.uploadUtilityBillReceiptEpic,
  appProperties.runUtilityBillsBotEpic,
  
  // ✅ NEW: App Communities epics
  appCommunities.getCommunityAggregatedStatsEpic,
  appCommunities.getNeighborsNoticesEpic,
  appCommunities.getNeighborsCalendarEpic,
  appCommunities.getNeighboursFilesEpic,
  appCommunities.getNeighboursServicesEpic,
  appCommunities.getNeighboursMeetingsEpic,
  appCommunities.getNeighboursWalletsEpic,
  appCommunities.getNeighborsPollsEpic,
  appCommunities.getNeighborsPaymentsEpic,
  
  // ✅ ADD: Missing Properties epics
  appProperties.getPropertyFoldersEpic,
  
  // ✅ ADD: Missing Communities epics  
  appCommunities.getCommunityChatsEpic,
  appCommunities.getCommunityTransactionsEpic,
  appCommunities.getCommunityBankAccountsEpic,
  appCommunities.getCommunityFoldersEpic,
  appCommunities.getCommunityMembersEpic,
  appCommunities.getCommunityAdministratorsEpic,
  appCommunities.getCommunityPrintOrdersEpic,
  
  // ✅ ADD: Missing Communities epics for legacy grids
  appCommunities.getCommunityPollsEpic,
  appCommunities.getCommunityFundsEpic,
  appCommunities.getCommunityUtilityBillsEpic,
  
  // ✅ KEEP: Other existing epics
  finances.getGeneratedIncomesEpic,
  finances.getPotentialIncomeEpic,
  users.getUsersEpic,
  merchants.getMerchantsListEpic,
  merchants.getPendingListEpic,
  merchants.addPendingEpic,
  merchants.deletePendingEpic,
  merchants.getCurrentMerchantEpic,
  merchants.editMerchantEpic,
  merchants.deleteMerchantEpic,
  merchants.searchMerchantsEpic,
  website.getArticlesEpic,
  website.addArticleEpic,
  website.getSingleArticleEpic,
  website.editArticleEpic,
  website.deleteArticleEpic,
);
